

























import { Vue, Component } from "vue-property-decorator";
import api from "@/getinfo-api";
import { ExpulsionOrder as IExpulsionOrder } from "@/api/models/expulsion-order";
import ExpulsionOrderFormEdit from "@/components/expulsion/ExpulsionOrderFormEdit.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, ExpulsionOrderFormEdit }
})
export default class expulsionOrderEdit extends Vue {
  expulsionData!: IExpulsionOrder;

  data() {
    return {
      expulsionData: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "expulsionList" },
        label: this.$tc(this.$translate.OrdersOfCompletion)
      },
      {
        to: {
          name: "expulsionOrder",
          params: { expulsionId: this.expulsionData.id }
        },
        label: this.expulsionData.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getExpulsionData() {
    api.ExpulsionOrderApi.get(this.$route.params.expulsionId).then(
      (res: { data: IExpulsionOrder }) => {
        this.expulsionData = res.data;
      }
    );
  }

  mounted() {
    this.getExpulsionData();
  }
}
